import dayjs from 'dayjs';

const isWeekday = () => {
  const dayOfWeek = dayjs().day();
  return dayOfWeek > 0 && dayOfWeek < 6;
};

export default isWeekday;
